import { render, staticRenderFns } from "./ActiveFluctuationRates.vue?vue&type=template&id=5bdae807&scoped=true&"
import script from "./ActiveFluctuationRates.vue?vue&type=script&lang=js&"
export * from "./ActiveFluctuationRates.vue?vue&type=script&lang=js&"
import style0 from "./ActiveFluctuationRates.vue?vue&type=style&index=0&id=5bdae807&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdae807",
  null
  
)

export default component.exports